import styled from 'styled-components';

export const Base = styled.div`
	position: relative;
	height: 100vh;
	background-color: ${({ theme }) => theme.gray[0]};

	background-color: #ffffff;
	width: 100%;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const Content = styled.div`
	padding-top: 90px;
	padding-left: 60px;
	padding-right: 60px;
	padding-bottom: 60px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 60px;
	max-width: 100%;
	box-sizing: border-box;

	@media (max-width: 768px) {
		padding-top: 40px;
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 40px;
		gap: 40px;
	}
`;

export const LeftColumn = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 650px;
	gap: 20px;
	box-sizing: border-box;

	@media (max-width: 768px) {
		max-width: 500px;
		gap: 16px;
	}

	@media (max-width: 525px) {
		max-width: 100%;
	}
`;

export const RightColumn = styled.div`
	width: 100%;
	max-width: 400px;
	display: flex;
	justify-content: center;
	box-sizing: border-box;

	img {
		width: 100%;
		height: auto;
		max-width: 400px;
	}

	@media (max-width: 768px) {
		max-width: 280px;

		img {
			max-width: 280px;
		}
	}

	@media (max-width: 525px) {
		max-width: 100%;

		img {
			max-width: 300px;
		}
	}
`;

export const Headline = styled.div`
	font-size: 80px;
	font-family: 'F37Judge-MediumCondensed', sans-serif;
	line-height: 1.1;

	@media (max-width: 768px) {
		font-size: 48px;
	}
`;

export const Body = styled.div`
	font-size: 24px;
	font-family: 'Inter', sans-serif;
	line-height: 1.45;
	letter-spacing: -0.02em;

	@media (max-width: 768px) {
		font-size: 18px;
		line-height: 1.5;
	}
`;

export const Button = styled.button`
	background-color: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[1000]};
	border: 2px solid ${({ theme }) => theme.gray[800]};
	font-family: 'Inter', sans-serif;
	font-size: 18px;
	font-weight: 500;
	padding: 0 24px;
	height: 44px;
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	flex-shrink: 0;
	white-space: nowrap;

	&:hover:not(:disabled) {
		background-color: ${({ theme }) => theme.gray[400]};
		border-color: ${({ theme }) => theme.gray[700]};
	}

	&:active:not(:disabled) {
		background-color: ${({ theme }) => theme.gray[600]};
		border-color: ${({ theme }) => theme.gray[600]};
	}

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}

	@media (max-width: 768px) {
		font-size: 16px;
		padding: 0 20px;
		height: 44px;
	}
`;

export const InviteCodeContainer = styled.div`
	display: flex;
	gap: 8px;
	margin-top: 20px;
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;

	@media (max-width: 768px) {
		margin-top: 12px;
		gap: 8px;
	}
`;

export const InviteCodeInput = styled.input`
	flex: 1;
	border: 2px solid ${({ theme }) => theme.gray[800]};
	font-size: 18px;
	padding: 10px 12px;
	background-color: ${({ theme }) => theme.gray[1000]};
	color: ${({ theme }) => theme.gray[200]};
	outline: none;
	font-family: 'Inter', sans-serif;
	box-sizing: border-box;
	min-width: 0;
	height: 44px;
	transition: all 0.2s ease-in-out;

	&:focus {
		border-color: ${({ theme }) => theme.gray[600]};
		background-color: ${({ theme }) => theme.gray[1000]};
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}

	&::placeholder {
		color: ${({ theme }) => theme.gray[700]};
	}

	@media (max-width: 768px) {
		font-size: 16px;
		padding: 10px 12px;
		height: 44px;
	}
`;

export const ErrorMessage = styled.div`
	color: ${({ theme }) => theme.red[500]};
	font-size: 20px;
	font-family: 'Inter', sans-serif;
	margin-top: -8px;
	margin-bottom: 12px;

	@media (max-width: 768px) {
		font-size: 16px;
		margin-bottom: 8px;
	}
`;

export const EmailAddress = styled.span`
	font-family: 'Inter', sans-serif;
	font-weight: 600;
`;

export const EmailLink = styled.a`
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	color: inherit;
	text-decoration: none;
	transition: opacity 0.2s ease-in-out;

	&:hover {
		opacity: 0.6;
	}
`;
